module.exports = __webpack_public_path__ + "media/images/icons/shop-2c9720cc301033ff8cb79fd9e4606ab9.svg";